import type { ReactElement } from 'react';

import { useSlideSnap } from '../lib/use-slide-snap';
import { EducationHero } from './education-hero';
import { EducationCta, EducationFaq, EducationPortfolio } from './education-sections';
import { EducationProcess } from './process-slide';
import { EducationServices } from './service-slides';
import { EducationTestimonials } from './testimonials';

/**
 * 교육 랜딩 — 1차 오픈 범위 §6.3-1.
 *
 * **설득이 일인 화면이다.** 폼은 별도 페이지(`/education/inquiry`)로 뺐다 —
 * 랜딩은 설득이 일이고 폼은 입력이 일이라, 한 페이지에 두면 둘 다 흐려진다.
 *
 * 히어로(약속) → 서비스 안내 01·02(무엇을 하나) → 교육 프로세스 03(어떻게 진행되나)
 * → 사례 04(증거) → 후기 05(다른 사람도 했다) → FAQ 06 순으로, 마지막에 문의로 보낸다.
 *
 * 넓은 화면에서는 스크롤이 슬라이드처럼 한 장씩 끊긴다(use-slide-snap). 섹션 하나가 한 장이고,
 * 각 슬라이드가 스스로 `u-slide` 를 단다. 끝 CTA 만 모양이 달라 여기서 감싸 멈춤 지점을 준다.
 */
export function EducationPage(): ReactElement {
  useSlideSnap();

  return (
    <div className="flex flex-col">
      <EducationHero />
      <EducationServices />
      <EducationProcess />
      <EducationPortfolio />
      <EducationTestimonials />
      <EducationFaq />
      <div className="u-slide">
        <EducationCta />
      </div>
    </div>
  );
}
